import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { BrowserTitleService } from '../../../commonInfra/services/BrowserTitleService';
import { SpaceContainerStyles } from '../../../style/SpaceContainerStyles';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { CollectionDefinition } from '../../../ts/models/ContentDefinitions';
import { ConnectedExplorer } from '../Explorer/ConnectedExplorer';
import { ExplorerStyles } from '../Explorer/ExplorerStyles';
import { createContentButton } from '../SubspaceHelpers';


export interface AllCollectionsSpaceOwnProps extends ReactDirectiveProps {}

export interface AllCollectionsSpaceStateProps {
  readonly isBusyFetchingItems: boolean;
  readonly numberOfFetchedCollections: number;
}

export interface AllCollectionsSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
}

export type AllCollectionsSpaceProps = AllCollectionsSpaceOwnProps & AllCollectionsSpaceStateProps & AllCollectionsSpaceDispatchProps;

export class AllCollectionsSpace extends React.PureComponent<AllCollectionsSpaceProps> {
  public componentDidMount() {
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.collections() });
    this.props.requestSpaceContents();
  }

  public render(): JSX.Element {
    return(
      <div className={ SpaceContainerStyles.SpaceContainer }>
        <div className={SpaceContainerStyles.MastheadArea}>
          <div className={ExplorerStyles.SpaceHeaderContent}>
            <div className={ExplorerStyles.SpaceHeaderText}>{Messages.collectionsSpaceLabel()}</div>
          </div>
        </div>
        <div className={ SpaceContainerStyles.SubplaceArea }>
          <ConnectedExplorer
            angularContext={this.props.angularContext}
            supportedDisplayModes={CollectionDefinition.supportedDisplayModes}
            toolbarProps={{
              supportFilterPanel: true,
              toolbarVisibility: 'enabled',
              toolbarContentSpecificControls: { beginning: createContentButton({spaceType: 'collections'}) }
            }}
            emptyStateProps={{
              primaryMessage: Messages.collectionsEmptyMessage()
            }}
          />
        </div>
      </div>
    );
  }
}
